exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".controls[data-v-3f564b1e]{float:right;padding-left:10px}", ""]);

// exports
